var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Styles from './lessons-quiz-styles.scss';
import Quiz from '@/presentation/components/lessons/quiz/quiz';
import { lessonState } from '../lessons/components/atoms';
import { useRecoilState } from 'recoil';
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import useLessons from '@/presentation/hooks/use-lessons';
import useStudentAccounts from '@/presentation/hooks/use-student-accounts';
import { ButtonKVBase, DefaultModal, InputKVBase } from '@/presentation/components';
import ErrorTransfer from '@/presentation/components/icons/error-transfer';
import ErrorRuleTransfer from '@/presentation/components/icons/error-rules';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
const LessonsQuiz = ({ manageQuizzesUsers, manageProgressService, loadLessons, manageVirtualTransactions, manageUsers }) => {
    var _a, _b, _c, _d, _e, _f;
    const [state, setState] = useState({
        quizUsersModel: null,
        savings: '',
        investments: ''
    });
    /*   const [studentWalletState] = useRecoilState(studentAccountsState); */
    const navigate = useNavigate();
    const { user, getClient } = useUserSesssion();
    const client = getClient();
    const { getAccounts, refeshAccounts } = useStudentAccounts(false);
    const { idModule, idLesson } = useParams();
    const { menuItemsState } = useLessons({ manageProgressService, Styles, loadLessons });
    const [stateLesson] = useRecoilState(lessonState);
    const [activities, setActivities] = useState([]);
    const [payQuiz, setOpenPayQuiz] = useState(false);
    const [modalError, setModalError] = useState(false);
    const [disable, setDisable] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);
    const accounts = getAccounts();
    const [cashoutResponse, setCashoutResponse] = useState(null);
    const { showCustomSuccess, showCustomError } = useCustomToast({
        containerId: 'main-dashboard-container'
    });
    const quiz = (_a = stateLesson === null || stateLesson === void 0 ? void 0 : stateLesson.lesson) === null || _a === void 0 ? void 0 : _a.lessonsQuizzes[0];
    const idQuiz = quiz === null || quiz === void 0 ? void 0 : quiz.id;
    const getData = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setDataLoading(true);
            const qb = RequestQueryBuilder.create();
            qb.setFilter({ field: 'userId', operator: CondOperator.EQUALS, value: user.id });
            qb.setFilter({ field: 'quizzesId', operator: CondOperator.EQUALS, value: idQuiz });
            qb.setFilter({ field: 'lessonId', operator: CondOperator.EQUALS, value: idLesson });
            const dataUserResults = yield manageQuizzesUsers.find({ queryBuilder: qb });
            if (dataUserResults.length > 0) {
                const dataUserResult = dataUserResults[0];
                setState(prev => (Object.assign(Object.assign({}, prev), { quizUsersModel: dataUserResult })));
            }
        }
        catch (error) {
            console.error('Error', error.message);
        }
        finally {
            setDataLoading(false);
        }
    });
    const getStudentCashout = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const res = yield manageUsers.studentFindStudentCashout();
            if (res) {
                setCashoutResponse(res);
            }
        }
        catch (error) {
            console.log(error);
            showCustomError('Error', 'Error loading data');
        }
    });
    useEffect(() => {
        if (idQuiz)
            getData();
        getStudentCashout();
    }, [idQuiz]);
    const onClickBackModule = () => {
        navigate(activities.length > 0
            ? `/student-dashboard/my-modules/${idModule}/lessons/${idLesson}/activity/${activities[0].name}`
            : `/student-dashboard/my-modules/${idModule}`);
    };
    const onClickQuiz = () => {
        setOpenPayQuiz(true);
    };
    useEffect(() => {
        var _a;
        const totalTransfer = Number.parseFloat(state.investments) + Number.parseFloat(state.savings);
        if (totalTransfer <= ((_a = state.quizUsersModel) === null || _a === void 0 ? void 0 : _a.KVBucks)) {
            setDisable(false);
        }
        else {
            setDisable(true);
        }
    }, [state]);
    useEffect(() => {
        const activities = menuItemsState.filter(data => {
            return (data === null || data === void 0 ? void 0 : data.type) === 'activity';
        });
        setActivities(activities);
    }, [menuItemsState]);
    const onTransferKV = () => __awaiter(void 0, void 0, void 0, function* () {
        var _g, _h, _j, _k;
        setLoading(true);
        const savingsPercent = (_h = (((_g = state.quizUsersModel) === null || _g === void 0 ? void 0 : _g.KVBucks) * 0.1)) === null || _h === void 0 ? void 0 : _h.toFixed(2);
        const investmentsPercent = (_k = (((_j = state.quizUsersModel) === null || _j === void 0 ? void 0 : _j.KVBucks) * 0.15)) === null || _k === void 0 ? void 0 : _k.toFixed(2);
        if (Number.parseFloat(state.investments) < Number.parseFloat(investmentsPercent) ||
            Number.parseFloat(state.savings) < Number.parseFloat(savingsPercent)) {
            setLoading(false);
            return setModalError(true);
        }
        const acount = accounts.find(data => data.accountType.description === 'Checking');
        const brokerageAcount = accounts.find(data => data.accountType.description === 'brokerage');
        const savingsAcount = accounts.filter(data => data.accountType.description === 'Pocket');
        try {
            const transfer1 = yield manageVirtualTransactions.makeTransaction({
                idAccountFrom: acount.id,
                idAccountTo: savingsAcount[0].id,
                amount: Number.parseFloat(state.savings)
            });
            const transfer2 = yield manageVirtualTransactions.makeTransaction({
                idAccountFrom: acount.id,
                idAccountTo: brokerageAcount.id,
                amount: Number.parseFloat(state.investments)
            });
            console.log('transfer1', transfer1);
            console.log('transfer2', transfer2);
            const resultUpdateUser = yield manageQuizzesUsers.update({
                id: state.quizUsersModel.id,
                payedQuiz: true
            });
            setState(prev => (Object.assign(Object.assign({}, prev), { quizUsersModel: Object.assign(Object.assign({}, prev.quizUsersModel), { payedQuiz: resultUpdateUser.payedQuiz }) })));
            yield refeshAccounts();
            showCustomSuccess('OK', "Done! You've paid yourself first!");
            refeshAccounts();
            setOpenPayQuiz(false);
        }
        catch (error) {
            console.error('Se produjo un error durante las transacciones:', error);
        }
        setLoading(false);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Quiz, { onClickBackModule: onClickBackModule, onClickBack: () => navigate(`/student-dashboard/my-modules/${idModule}/lessons/${idLesson}/keyword`), 
            // onClickStart={onClickStart}
            onClickPayQuiz: onClickQuiz, onClickCheckResults: () => navigate(`/student-dashboard/take-quiz/${idQuiz}?idModule=${idModule}&idLesson=${idLesson}`), onClickViewWallet: () => navigate('/student-dashboard/my-wallet/overview'), amountKV: (_b = state.quizUsersModel) === null || _b === void 0 ? void 0 : _b.KVBucks, title: (quiz === null || quiz === void 0 ? void 0 : quiz.name) || 'No quiz', percent: ((_c = state.quizUsersModel) === null || _c === void 0 ? void 0 : _c.percentResult) || 0, correctAnswers: (_d = state.quizUsersModel) === null || _d === void 0 ? void 0 : _d.correctAnswers, questions: (_e = state.quizUsersModel) === null || _e === void 0 ? void 0 : _e.totalQuestions, manageProgressService: manageProgressService, loadLessons: loadLessons, buttonTitle: activities.length > 0 ? `Go to Activity` : `Go back to Module`, payedQuiz: ((_f = state === null || state === void 0 ? void 0 : state.quizUsersModel) === null || _f === void 0 ? void 0 : _f.payedQuiz) || false, buttonPayQuizz: "Pay Yourself First", loading: dataLoading, cashoutResponse: cashoutResponse }),
        React.createElement(DefaultModal, { width: "40", wUnit: "%", padding: "46px", open: payQuiz, onClose: () => {
                setOpenPayQuiz(false);
            }, overlayCustomStyles: { zIndex: 3 }, contentCustomStyles: { display: 'flex', justifyContent: 'center' } },
            React.createElement("div", { className: Styles.modalWrap },
                React.createElement("div", { className: Styles.title }, "Pay Yourself First"),
                React.createElement("div", { className: Styles.subTitles },
                    React.createElement("div", null, `Let's build our money management muscles!`),
                    React.createElement("div", null, "Start by dividing your earnings using our 50/15/10/25 rule!")),
                React.createElement("div", { className: Styles.payButtons },
                    React.createElement(InputKVBase, { type: "text", name: "savings", placeholder: "$5,000", label: "Savings", state: state, setState: setState, defaultValue: '' }),
                    React.createElement(InputKVBase, { type: "text", name: "investments", placeholder: "$5,000", label: "Investments", state: state, setState: setState, defaultValue: '' })),
                React.createElement("div", { className: Styles.ruleBody },
                    React.createElement("div", { style: { display: 'flex', gap: '10px', alignItems: 'center' } },
                        React.createElement(ErrorRuleTransfer, { color: "#00a3ff" }),
                        React.createElement("span", null, "Rule of Thumb:")),
                    React.createElement("div", null,
                        React.createElement("ul", null,
                            React.createElement("li", null, "50% Essentials: Housing, Transportation, Utilities, Food, etc."),
                            React.createElement("li", null, "15% Investments"),
                            React.createElement("li", null, "10% Savings"),
                            React.createElement("li", null, "25% Everything else: Leisure and Entertainment")))),
                React.createElement(ButtonKVBase, { disabled: disable, loading: loading, type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", onClick: () => __awaiter(void 0, void 0, void 0, function* () { return onTransferKV(); }) }, "Confirm"))),
        React.createElement(DefaultModal, { width: "30", wUnit: "%", open: modalError, onClose: () => setModalError(false), overlayCustomStyles: { zIndex: 4 }, contentCustomStyles: { display: 'flex', justifyContent: 'center' } },
            React.createElement("div", { className: Styles.modalWrapError },
                React.createElement("div", { className: Styles.errorLogoTransfer },
                    React.createElement(ErrorTransfer, null)),
                React.createElement("div", { className: Styles.title }, "Oops!"),
                React.createElement("div", { className: Styles.subTitles },
                    React.createElement("div", null, "You need to pay at least 10% to Savings and 15% to investments to continue.")),
                React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", onClick: () => setModalError(false) }, "ok")))));
};
export default LessonsQuiz;
